export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const SET_AUTH = 'SET_AUTH';
export const INVALID_TOKEN = 'INVALID_TOKEN';
export const CHECK_SESSION = 'CHECK_SESSION';
export const TOKEN_RENEWED = 'TOKEN_RENEWED';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';

interface RenewToken {
  type: typeof SET_AUTH;
  payload: {
    isAuthenticated: boolean;
    accessToken: any;
    user: { name: any; email: any; picture: any };
    countryCode: string;
  };
}

interface TryLogin {
  type: typeof INVALID_TOKEN;
  payload: {
    isAuthenticated: boolean;
  };
}

interface LogOut {
  type: typeof LOG_OUT;
  payload: {
    isAuthenticated: boolean;
  };
}

export type AuthActions = RenewToken | TryLogin | LogOut;
